import type { SVGProps } from "react";

/**
 * chevron-left-medium
 * @category Arrows
 */
export default function IconChevronLeftMedium(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M14.5 18.25L8.25 12L14.5 5.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
